import { render, staticRenderFns } from "./Scale.vue?vue&type=template&id=2f914dde&scoped=true"
import script from "./Scale.vue?vue&type=script&lang=js"
export * from "./Scale.vue?vue&type=script&lang=js"
import style0 from "./Scale.vue?vue&type=style&index=0&id=2f914dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f914dde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
